import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import SurveyFormEditor from './SurveyFormEditor.vue';
import SurveyResponses from './SurveyResponses.vue';

// Route names are spelled out as literals on purpose: the sidebar guard spec
// scans route files for `name: '...'` to prove no menu entry points at a dead
// route, and a constant reference would slip past it.
// Authoring a questionnaire changes what every customer of the account sees,
// so the whole surface is administrator-only.
const meta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/surveys'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_surveys_index',
          meta,
          component: Index,
        },
        {
          path: 'new',
          name: 'settings_surveys_new',
          meta,
          component: SurveyFormEditor,
        },
        {
          path: ':formId/edit',
          name: 'settings_surveys_edit',
          meta,
          component: SurveyFormEditor,
        },
        {
          path: ':formId/responses',
          name: 'settings_surveys_responses',
          meta,
          component: SurveyResponses,
        },
      ],
    },
  ],
};
